<div class="light-blue-text" style="text-align: center; position: relative; backface-visibility: hidden">
  @if (naytaSuljeRuksi) {
    <app-button mat-dialog-close actionId="Sulje dialog" styles="position: absolute; right: -30px; top: 0; min-width: 0; padding: 0;">
      <i style="font-size: 40px; width: 40px; height: 40px; line-height: 40px; display: inline-block" class="icon ion-ios-close"></i>
    </app-button>
  }
  <h2 style="margin: 0; padding-top: 50px; padding-bottom: 30px"><ng-content></ng-content></h2>
</div>
